import { LoaderFunction } from 'react-router-dom';

// GraphQL
import { client } from '../../../gql/client';
import { FETCH_PREDEFINED_DATA_LISTS } from '../../../gql/queries/orders/predefinedData';
import { GET_SELECTORS_DATA } from '../../../gql/queries/orders/orders';
import { GET_SURVEILLANCE_ROUTE_PRESETS } from '../../../gql/queries/surveillanceRoutePresets';

// Offline
import { ensureRoadMesh } from '../../../offline/prefetchRoadMesh';

// Contexts
import { AuthContextType } from '../../../hooks/useAuth';

export const LoaderBaseDataMain: (
  userData: AuthContextType | null
) => LoaderFunction = (userData) => async () => {
  if (userData?.user) {
    // 🔴 PRIMERO, y no es cosmético.
    //
    // La cartografía para resolver el PK sin cobertura. Fire-and-forget: no
    // puede retrasar la navegación, y sin red se queda con lo que ya hubiera
    // en la tablet.
    //
    // Iba la última y se notaba: las dos consultas de datos maestros de abajo
    // son de las más pesadas del arranque en frío, y mientras están en vuelo
    // la cadena de Apollo no despacha esta. Medido en la E2E — con la malla
    // detrás, la consulta no llegaba a salir en 10 s; delante, sale al
    // instante. En una tablet eso significa bajarse el mapa justo cuando el
    // operario ya puede estar perdiendo la señal, que es lo contrario de lo
    // que esto existe para evitar.
    void ensureRoadMesh(client);

    Promise.all([
      client.query({
        query: FETCH_PREDEFINED_DATA_LISTS,
      }),
      client.query({
        query: GET_SELECTORS_DATA,
      }),
      // Plantillas de recorrido (2026-08-18). Se calientan AQUÍ, al arrancar,
      // por el mismo motivo que la malla: el asistente las lee `cache-first`, y
      // una tablet que sale a ruta y se queda sin señal debe encontrarlas ya
      // guardadas. Sin esta precarga, la primera vez que abriera el asistente
      // sin cobertura el desplegable no estaría — y no teclear el PK con
      // guantes y sin red es medio motivo de que las plantillas existan.
      //
      // Son unas pocas filas por tenant, así que no compite con las dos
      // consultas pesadas de arriba. `errorPolicy: 'ignore'`: un tenant sin
      // plantillas, o un backend anterior a esta query, no puede tumbar el
      // arranque de la aplicación.
      client.query({
        query: GET_SURVEILLANCE_ROUTE_PRESETS,
        variables: { onlyActive: true },
        fetchPolicy: 'cache-first',
        errorPolicy: 'ignore',
      }),
    ]);
  }

  return null;
};
